import { render, staticRenderFns } from "./policy-yuri-reivew.vue?vue&type=template&id=542becac&scoped=true&"
import script from "./policy-yuri-reivew.vue?vue&type=script&lang=js&"
export * from "./policy-yuri-reivew.vue?vue&type=script&lang=js&"
import style0 from "./policy-yuri-reivew.vue?vue&type=style&index=0&id=542becac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542becac",
  null
  
)

export default component.exports